import React, { useEffect, useState } from 'react';
import Styles from './styles.module.css';
import Items from './items';
import { offerCount } from '../../0.functions/offers';
import Loading from '../../9.items/loading/index';

type SchoolGradeGraphProps = {
  hashTags: string[];
  filteredUsers: any[];
  usersLoaded: boolean;
  schoolId: string;
};

const SchoolGradeGraph: React.FC<SchoolGradeGraphProps> = ({ hashTags, filteredUsers, usersLoaded, schoolId }) => {

  const [ pvCount, setPvCount ] = useState<number[]>([]);
  const [ saveCount, setSaveCount ] = useState<number[]>([]);
  const [ visitCount, setVisitCount ] = useState<number[]>([]);
  const [ desiredCount, setDesiredCount ] = useState<number[]>([]);
  const [ applyCount, setApplyCount ] = useState<number[]>([]);
  const [ jobOfferCount, setJobOfferCount ] = useState<number[]>([]);

  useEffect(() => {
    if (filteredUsers.length === 0 && hashTags.length >= 2) {
      setPvCount([]);
      setSaveCount([]);
      setVisitCount([]);
      setDesiredCount([]);
      setApplyCount([]);
      setJobOfferCount([]);
      return;
    }

    if (!filteredUsers || filteredUsers.length === 0 || hashTags.length <= 1) return;

    const pv = filteredUsers.reduce(
      (sum, u) => sum + (u.analytics?.pvCount ?? 0),
      0
    );

    const save = filteredUsers.reduce(
      (sum, u) => sum + (u.activity?.recruitSaves?.length ?? 0),
      0
    );

    const visit = filteredUsers.reduce(
      (sum, u) => sum + (u.activity?.recruitVisitList?.length ?? 0),
      0
    );

    const desired = filteredUsers.reduce(
      (sum, u) => sum + (u.analytics?.applyStatusCount?.志望先 ?? 0),
      0
    );

    const apply = filteredUsers.reduce(
      (sum, u) => sum + (u.analytics?.applyStatusCount?.応募済み ?? 0),
      0
    );

    // 内定承諾は、学生が登録しても学校が登録しても1人1件(内定のある学生の人数)
    const jobOffer = filteredUsers.reduce(
      (sum, u) => sum + offerCount(u, schoolId),
      0
    );

    // グラフ都合で「配列」でセット
    setPvCount([pv]);
    setSaveCount([save]);
    setVisitCount([visit]);
    setDesiredCount([desired]);
    setApplyCount([apply]);
    setJobOfferCount([jobOffer]);

  }, [hashTags, filteredUsers, schoolId]);

  return (
  <>
    <div className={Styles.works_service}>
      <div className={Styles.recruit_table_nav}>
        <h4 className={Styles.table_name}>項目</h4>
        <h4 className={Styles.table_data}>データ</h4>
      </div>

      {hashTags.length <= 2 ? 
      (
        <p className={Styles.recruit_none}>
          コース、学年、クラスを選択してください。
        </p>
      ) : !usersLoaded ? (
        <Loading />
      ) : filteredUsers.length === 0 ? (
        <p className={Styles.recruit_none}>
          該当するデータがありません。
        </p>
      ) : (
      <>
        <Items
          itemName="閲覧数"
          value={pvCount[0] ?? 0}
          barValue={Math.ceil((pvCount[0] ?? 0) / 10) * 10}
        />
        <Items
          itemName="お気に入り"
          value={saveCount[0] ?? 0}
          barValue={Math.ceil((saveCount[0] ?? 0) / 10) * 10}
        />
        <Items
          itemName="サロン見学"
          value={visitCount[0] ?? 0}
          barValue={Math.ceil((visitCount[0] ?? 0) / 10) * 10}
        />
        <Items
          itemName="志望先"
          value={desiredCount[0] ?? 0}
          barValue={Math.ceil((desiredCount[0] ?? 0) / 10) * 10}
        />
        <Items
          itemName="応募済み"
          value={applyCount[0] ?? 0}
          barValue={Math.ceil((applyCount[0] ?? 0) / 10) * 10}
        />
        <Items
          itemName="内定承諾"
          value={jobOfferCount[0] ?? 0}
          barValue={Math.ceil((jobOfferCount[0] ?? 0) / 10) * 10}
        />
      </>
      )}

    </div>
  </>
  );
}

export default SchoolGradeGraph;


